import moment from 'moment'
import * as sentry from '../../src/utils/sentry'
import { Auth_logout } from '../Auth/Auth.logout'
import { IDB_lastActivity } from '../IDB/IDB.dexie'
import { Rpts_openReportFetch } from '../Rpts/Rpts.OpenReport'
import { Sync_hasUnsyncedData } from '../Sync/Sync.hasUnsyncedData'
import { User_isLoggedIn } from '../User/User.get'
import { IDB_inactivitySettings } from '../IDB/IDB.deviceDB'

export interface Devi_InactivitySettings {
    on: boolean
    timeInMins: number
}

const defaultInactivitySettings = {
    on: false,
    timeInMins: 5,
}

export async function Devi_readInactivitySettings() {
    const settings = await IDB_inactivitySettings().get()
    return settings ?? defaultInactivitySettings
}

let timeout: number

/**
 * Both checks current inactivity and triggers a timeout to check again in future
 * If inactive, will only logout if there are no unsynced reports
 */
export async function Devi_inactivityCheck() {
    try {
        window.clearTimeout(timeout)

        if (!User_isLoggedIn()) return

        const settings = await Devi_readInactivitySettings()
        if (!settings.on) return

        const lastActive = await IDB_lastActivity().get()
        const now = moment()
        const logoutTime = moment(lastActive).add(settings.timeInMins, 'minutes')

        // If still active
        if (logoutTime.isAfter(now)) {
            timeout = window.setTimeout(Devi_inactivityCheck, logoutTime.diff(now))
            return
        }

        // Ignore if there's an open report
        const openReport = await Rpts_openReportFetch()
        if (openReport != null) return

        // Ignore if unsynced data
        if (await Sync_hasUnsyncedData()) return

        Auth_logout()
    } catch (error) {
        sentry.err(error, {})
        timeout = window.setTimeout(Devi_inactivityCheck, 60 * 60 * 1000)
    }
}
